module.exports = __webpack_public_path__ + "static/EnmTX_BosGareth_L_A_cl-4a6ab8eb6e4364c1b19131b279dd80b1.gif";